import React from 'react'
import {Box, Spinner} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

const LoadingSpinner = ({wrapperStyles = {}, spinnerStyles = {}}) => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            {...wrapperStyles}
        >
            <Spinner
                data-testid="loading"
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.600"
                size="xl"
                {...spinnerStyles}
            />
        </Box>
    )
}

LoadingSpinner.propTypes = {
    wrapperStyles: PropTypes.object,
    spinnerStyles: PropTypes.object
}

export default LoadingSpinner
